import { Suspense } from "react";

import Loader from "./Loader";

const Loadable = (Component: any) => () =>
  (
    <Suspense fallback={<Loader />}>
      <Component />
    </Suspense>
  );

export default Loadable;
